import {createContext} from 'react';

// Speaker-panel UI state shared between SpeakerBar/SpeakerRoster (which
// set it), Block.js (which reads focus to dim non-matching turns), and
// the top-level keyboard shortcut handler (S toggles rosterOpen).
// `focus` is a Set of selected speaker names (empty = no filter).
const SpeakerFocusContext = createContext({
  focus: new Set(),
  setFocus: () => {},
  rosterOpen: false,
  setRosterOpen: () => {}
});

export default SpeakerFocusContext;
